/**
 * @generated SignedSource<<bde7eab84532c1cc0e96a07c0129e9a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShowSkuImagesGalleryButton_ProductSkuImageConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly __typename: string;
  }>;
  readonly " $fragmentType": "ShowSkuImagesGalleryButton_ProductSkuImageConnection";
};
export type ShowSkuImagesGalleryButton_ProductSkuImageConnection$key = {
  readonly " $data"?: ShowSkuImagesGalleryButton_ProductSkuImageConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShowSkuImagesGalleryButton_ProductSkuImageConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShowSkuImagesGalleryButton_ProductSkuImageConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuImageEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductSkuImageConnection",
  "abstractKey": null
};

(node as any).hash = "9fdccbbe53a0d29ac1850075b1e28215";

export default node;
